// 今はdocument下だが移したいものがある.明示的に参照を書く.
// TODO: 見直せるタイミングで階層変更したい.
export { MuscularStrengthInputKinds as ManualMuscleTestInputMethods } from "../../../../../domain/document";
